import React from 'react';
import { observer } from 'mobx-react';

import CodeMirror from 'core/components/CodeMirror';

const Component = observer((props) => {
  const { field, mode, codeMirrorOptions } = props;

  const onChange = (editor, data, value) => {
    field.onChange(value);
  };

  return <CodeMirror value={field.getValue()} onChange={onChange} mode={mode} options={codeMirrorOptions} />;
});

Component.displayName = 'CodeMirror';

export default Component;
